const resolvePosition = value => {
  if (!value) {
    return '0';
  }
  if (typeof value === 'string') {
    return value;
  }
  return `${value}px`;
};
const slideOutDefaultStyle = (theme, panelWidth, hasOverflow, bottom, top) => ({
  '&.MuiDrawer-root': {
    top: resolvePosition(top),
    bottom: resolvePosition(bottom)
  },
  '.MuiDrawer-paper': {
    boxSizing: 'border-box',
    boxShadow: hasOverflow ? 'none' : `-2px 0px 6px ${theme.tokens.ComponentSlideOutRootBoxShadow}, 2px 0px 6px ${theme.tokens.ComponentSlideOutRootBoxShadow}`,
    width: typeof panelWidth === 'string' ? panelWidth : `${panelWidth}px`,
    position: 'absolute'
  },
  ' .MuiBackdrop-root': {
    top: resolvePosition(top),
    bottom: resolvePosition(bottom),
    backgroundColor: `color-mix(in srgb,${theme.tokens.ComponentSlideOutBackdropColor} 80%, transparent)`
  },
  '& ~ .interstate-reference': {
    zIndex: 1300
  }
});
export { slideOutDefaultStyle };